import { graphql, HeadProps, PageProps } from 'gatsby';
import React from 'react';
import ReactDOM from 'react-dom';
import { SEO } from '@zempler/theme/src/components/Seo';
import { HeroComponentRenderer } from '../components/componentRenderer/HeroComponentRenderer';
import { PageComponentRenderer } from '../components/componentRenderer/PageComponentRenderer';

if (process.env.NODE_ENV !== 'production') {
  const axe = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

const Page = ({ data }: PageProps<Queries.UmbracoPageQuery>) => {
  const url = data?.page?.url;
  const properties = data?.page?.properties;
  const pageComponents = properties?.pageComponents;
  const heroComponents = properties?.heroComponents;
  const pageComponentsData = pageComponents?.[0]?.block?.components;
  const heroComponentsData = heroComponents?.[0]?.block?.components;

  return (
    <>
      <HeroComponentRenderer components={heroComponentsData} />
      <PageComponentRenderer components={pageComponentsData} />
    </>
  );
};

export default Page;

export const Head = ({ data }: HeadProps<Queries.UmbracoPageQuery>) => {
  const seo = data.page?.properties?.seo;
  const feedImg = data.page?.properties?.feed?.featuredImage?.image?.localFile?.ogImg?.src;
  const heroImg = data?.page?.properties?.heroComponents[0]?.block?.components?.[0]?.image?.image ? data.page.properties.heroComponents[0].block.components[0].image.image.localFile?.ogImg?.src : undefined

  return <SEO data={seo} image={`${data.site.siteMetadata.siteUrl}${feedImg || heroImg || undefined }`} />;
};

export const umbracoPageQuery = graphql`
  query UmbracoPage($id: String!) {
    site {
        siteMetadata {
          siteUrl
        }
    }
    page: umbracoPageType(id: { eq: $id }) {
      name
      remoteId
      url
      hideNavigation
      pageSitewideBanner {
        backgroundColour
        bannerId
        description
        enabled
        heading
        icon
        disableSiteWideBanner
      }
      properties {
        ...PageComponents
        ...HeroComponents
        seo {
          ...SEO
        }
        feed {
          featuredImage {
            image {
              ...OgImage
            }
          }
        }
      }
    }
  }
`;


